import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safehtml', standalone: true })
export class SafehtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);


  transform(html: string): unknown {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
